var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCornerOneFrame2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 285,
    viewBox: "0 0 400 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M256.787 125.387H62.7887C28.1641 125.387 0.0952454 97.3179 0.0952454 62.6932C0.0952454 28.0686 28.1641 -0.000228882 62.7887 -0.000228882H194.833C229.049 -0.000228882 256.787 27.7374 256.787 61.9535V125.387Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M125.482 205.281L62.7882 205.281L0.0947211 205.281C0.0947241 170.657 28.1636 142.588 62.7882 142.588C97.4128 142.588 125.482 170.657 125.482 205.281Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M125.482 222.307L62.7882 222.307L0.0947211 222.307C0.0947241 256.931 28.1636 285 62.7882 285C97.4128 285 125.482 256.931 125.482 222.307Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.189 62.8771L336.495 62.8771L273.802 62.8771C273.802 28.2524 301.871 0.183596 336.495 0.183599C371.12 0.183602 399.189 28.2524 399.189 62.8771Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M131.4 148.504L194.094 148.504L256.787 148.504C256.787 183.128 228.718 211.197 194.094 211.197C159.469 211.197 131.4 183.128 131.4 148.504Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCornerOneFrame2);
export default __webpack_public_path__ + "static/media/CornerOneFrame2.a416dc307c2c870397f2cd834aa5e063.svg";
export { ForwardRef as ReactComponent };